import users from './users';

export default function subscriber(backendAxiosInstance) {
  return {
    ...users(backendAxiosInstance),
    // TODO: Add functions to call subcriber endpointsq
    // Check ../content/index.js for reference
  };
}
